import React from "react"

export default () => (
  <svg width="24px" height="24px" viewBox="0 0 24 24">
    <polygon points="10 5 10 8 12.21 8 8.79 16 6 16 6 19 14 19 14 16 11.79 16 15.21 8 18 8 18 5" />
  </svg>
)
